import * as React from "react";

const CaretDown: React.FC = () => {
    return <svg width="8px" height="4px" viewBox="0 0 8 4" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-631.000000, -365.000000)" fill="currentColor">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(552.000000, 135.000000)">
                    <polygon points="8 -3.63709063e-13 4 4 1.82076576e-13 -3.63709063e-13"></polygon>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(CaretDown);
